import React, { useState } from 'react';
import Typography from '../../../basic/Typography';
import './ImagePreview.css';

interface ImagePreviewProps {
  src: string;
  alt: string;
  fileName: string;
  fileSize: number;
}

export const ImagePreview: React.FC<ImagePreviewProps> = ({
  src,
  alt,
  fileName,
  fileSize,
}) => {
  const [isLoading, setIsLoading] = useState(true);
  const [hasError, setHasError] = useState(false);

  const formatFileSize = (bytes: number): string => {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
  };

  const handleImageLoad = () => {
    setIsLoading(false);
  };

  const handleImageError = () => {
    setIsLoading(false);
    setHasError(true);
  };

  return (
    <div className="image-preview">
      <div className="preview-header">
        <Typography variant="h4" gutterBottom={false}>
          Image Preview
        </Typography>
        <div className="file-info">
          <span className="file-name">{fileName}</span>
          <span className="file-size">({formatFileSize(fileSize)})</span>
        </div>
      </div>

      <div className="preview-container">
        {isLoading && (
          <div className="loading-overlay">
            <div className="loading-spinner"></div>
            <Typography variant="body2" gutterBottom={false}>
              Loading preview...
            </Typography>
          </div>
        )}

        {hasError ? (
          <div className="error-overlay">
            <Typography variant="body2" gutterBottom={false}>
              Failed to load image preview
            </Typography>
          </div>
        ) : (
          <img
            src={src}
            alt={alt}
            onLoad={handleImageLoad}
            onError={handleImageError}
            className={`preview-image ${isLoading ? 'loading' : ''}`}
          />
        )}
      </div>
    </div>
  );
};
